import React from 'react'

const FilterIcon = (props: any) => (
  <svg width="22" height="22" viewBox="0 0 22 22" {...props}>
    <path d="M20.7728 0.414062H1.69925C0.822833 0.414062 0.380598 1.47745 1.00159 2.09844L8.60481 9.70282V18.1742C8.60481 18.4961 8.7619 18.7979 9.02567 18.9825L12.3146 21.2839C12.9634 21.7381 13.8671 21.2778 13.8671 20.4756V9.70282L21.4705 2.09844C22.0902 1.47868 21.651 0.414062 20.7728 0.414062Z" />
  </svg>
)

export default FilterIcon
